import { render, staticRenderFns } from "./WeIconButton.vue?vue&type=template&id=1c39c5d3&scoped=true&"
import script from "./WeIconButton.vue?vue&type=script&lang=js&"
export * from "./WeIconButton.vue?vue&type=script&lang=js&"
import style0 from "./WeIconButton.vue?vue&type=style&index=0&id=1c39c5d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c39c5d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
